import api from '@/services/api';
import router from '@/services/router';
import routes from '@/services/router/routes';
import { loadUserState, signOut } from '@/services/auth';

import {
  checkPrivacy,
  getLayoutFromMeta,
  multiguard,
  updateDocumentTitle,
} from '@/services/router/navigation-guards';

export default () => {
  loadUserState();

  // Add route and navigation guards
  router.addRoutes(routes);

  router.beforeEach(multiguard([
    checkPrivacy('private'),
  ]));

  router.afterEach(multiguard([
    getLayoutFromMeta('LayoutBase'),
    updateDocumentTitle('Clientes Loyall'),
  ]));

  // Add API request interceptors
  api.request.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        signOut(router.currentRoute.fullPath);
      }

      if (error.response?.status === 403) {
        router.push('/error-403');
      }

      return Promise.reject(error);
    },
  );
};
